import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirGhostSourcingService {

  constructor(private http: HttpClient) { }

  triggerSourcing(returnClobSettingsObj: any, ecSaveDtls: any[], baseUrl: string, globalService: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=jx71so`;
    const filterParams = globalService?.filterParams || {};
    const jsonObj = JSON.stringify(ecSaveDtls);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);
    let params = { ...filterParams };
    params.combination_key = returnClobSettingsObj.combination_key;
    params.sso_id = returnClobSettingsObj.sso_id;
    
    if (globalService?.globalParams) {
      params = { ...globalService.globalParams, ...params };
    }
    
    params = { ...params, clob_data: jsonObj, clob_settings: jsonSettings };
    params.process_name = "TRIGGER_GHOST_DEFAULT_SOURCING";

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    const options = {
      withCredentials: true
    };
    
    return this.http.post<any>(url, formData, options).pipe(
      catchError((error: any) => {
        throw error;
      })
    );
  }
} 
